var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5C5.87262 0.5 0.5 5.87262 0.5 12.5C0.5 19.1278 5.87262 24.5 12.5 24.5C19.1278 24.5 24.5 19.1278 24.5 12.5C24.5 5.87262 19.1278 0.5 12.5 0.5ZM12.5 23.0236C6.71037 23.0236 2 18.2896 2 12.5C2 6.71033 6.71037 1.99995 12.5 1.99995C18.2896 1.99995 23 6.71035 23 12.5C23 18.2896 18.2896 23.0236 12.5 23.0236ZM17.2891 8.10913L10.2485 15.194L7.07785 12.0234C6.78498 11.7305 6.31023 11.7305 6.01698 12.0234C5.7241 12.3162 5.7241 12.791 6.01698 13.0839L9.7291 16.7964C10.022 17.0889 10.4967 17.0889 10.79 16.7964C10.8237 16.7626 10.8526 16.7259 10.8789 16.6876L18.3504 9.16998C18.6429 8.8771 18.6429 8.40235 18.3504 8.10913C18.0571 7.81625 17.5824 7.81625 17.2891 8.10913Z",
    fill: "#00A930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/checkGreen.e2385abd2d811186d9029b749063ddbc.svg";
export { ForwardRef as ReactComponent };